import { Leaf } from "lucide-react";

const WORDS = ["Soonyoung", "Botanical", "Couture", "Sanctuary"];

export default function EditorialMarquee({ data }) {
  const words = data?.words?.length ? data.words : WORDS;
  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-champagne/10 bg-pine/40 py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee-editorial items-center gap-10">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center gap-10">
            {words.map((w, i) => (
              <div key={`${copy}-${w}`} className="flex items-center gap-10">
                <span
                  className={`whitespace-nowrap font-display text-5xl sm:text-7xl ${
                    i % 2 === 0 ? "italic text-cream/90" : "text-stroke-gold"
                  }`}
                >
                  {w}
                </span>
                <Leaf className="h-6 w-6 shrink-0 text-gold/40" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
